export class TimeUtil {
  // Get a date in the future with the offset specified in the parameters
  public static getTimeFromNow(
    days : number,
    hours : number,
    minutes : number,
    seconds : number,
  ) : Date {

    const now = new Date();
    return new Date(
      now.getTime()
        + seconds * 1000
        + minutes * 1000 * 60
        + hours * 1000 * 60 * 60
        + days * 1000 * 60 * 60 * 24,
    );
  }

  // By safe, we mean that the string could be used in a file name
  public static getCurrentTimeAsStringSafe() : string {
    return TimeUtil.getDateAsStringSafe(new Date());
  }

  // By safe, we mean that the string could be used in a file name
  public static getDateAsStringSafe(date : Date) : string {

    const sYear = String(date.getFullYear());
    const sMonth = String(date.getMonth() + 1).padStart(2, '0');
    const sDay = String(date.getDate()).padStart(2, '0');

    const sHour = String(date.getHours()).padStart(2, '0');
    const sMin = String(date.getMinutes()).padStart(2, '0');
    const sSec = String(date.getSeconds()).padStart(2, '0');

    return `${sYear}${sMonth}${sDay}_${sHour}${sMin}${sSec}`;
  }
}
